// helpers/formatDatesForApi.js
import { parse, format, isValid } from 'date-fns';

/**
 * Convert date fields in an object to the desired format.
 * @param {Object} data - The data object containing date fields.
 * @param {Array} dateFields - An array of keys in the object that represent dates.
 * @param {string} fromFormat - The current format of the date fields.
 * @param {string} toFormat - The desired output date format.
 * @returns {Object} - The updated object with formatted date fields.
 */

export const parseToISODate = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  const [day, month, year] = ddmmyyyy.split('/').map(Number);
  return new Date(year, month - 1, day).toISOString();
};

//object
export const convertDatesForApi = (
  data,
  dateFields,
  fromFormat = 'dd/MM/yyyy',
  toFormat = 'yyyy-MM-dd'
) => {
  const updatedData = { ...data };

  dateFields.forEach((field) => {
    if (updatedData[field]) {
      const parsedDate = parse(updatedData[field], fromFormat, new Date());
      if (isValid(parsedDate)) {
        updatedData[field] = format(parsedDate, toFormat);
      }
    }
  });

  return updatedData;
};

export const deepConvertDatesForApi = (
  data,
  dateFields,
  fromFormat = 'dd/MM/yyyy',
  toFormat = 'yyyy-MM-dd'
) => {
  if (Array.isArray(data)) {
    return data.map((item) =>
      deepConvertDatesForApi(item, dateFields, fromFormat, toFormat)
    );
  }

  if (typeof data === 'object' && data !== null) {
    const updatedData = { ...data };

    Object.keys(updatedData).forEach((key) => {
      if (dateFields.includes(key) && updatedData[key]) {
        const parsedDate = parse(updatedData[key], fromFormat, new Date());
        if (isValid(parsedDate)) {
          updatedData[key] = format(parsedDate, toFormat);
        }
      } else if (typeof updatedData[key] === 'object') {
        updatedData[key] = deepConvertDatesForApi(
          updatedData[key],
          dateFields,
          fromFormat,
          toFormat
        );
      }
    });

    return updatedData;
  }

  return data;
};
